import React from 'react';
import './style.scss';

/**
 * SimpleTableContent component - simplified component, without subContent.
 *
 * @param {Object} props - Props for the SimpleTableContent component.
 * @param {string} props.title - The title of the content block.
 * @param {string} props.mainContent - The main content of the block.
 * @param {string} [props.mainContentClass] - The CSS class for the main content block.
 * @param {string} props.mainContentAriaLabel - The aria-label text for the main content.
 * @param {string} props.translationMainContent - The translation key for the main content.
 * @returns {JSX.Element} The SimpleTableContent component.
 * @example
 *  <SimpleTableContent 
        mainContent={'mainContent Text'} 
        mainContentAriaLabel={'mainContent Text ariaLabel'}
        translationMainContent={'mainContent Title Translation'}
    />
 */
function SimpleTableContent({ title, mainContent, mainContentClass, mainContentAriaLabel, translationMainContent }) {
    return (
        <div className="info-content-block">
            <div className="title">
                {title}
            </div>
            <div className={`main-content ${mainContentClass}`}>
                <span tabIndex={0} aria-label={`${translationMainContent} ${mainContentAriaLabel}`}>{mainContent}</span>
            </div>
        </div>
    )
};

SimpleTableContent.defaultProps = {
    title: '',
    mainContent: '',
    mainContentClass: '',
    mainContentAriaLabel: '',
    translationMainContent: '',
};

export default SimpleTableContent;
